{
  "es": {
    "survey_type": {
      "actions": {
        "changeResponsible": "Cambiar responsable"
      },
      "attributes": {
        "introduction": "Introducción",
        "responsible": "Responsable",
        "title": "Título"
      },
      "labels": {
        "ask_question": "¿Qué tipo de pregunta quieres hacer?",
        "editInternalTitle": "¿Editar el título interno?",
        "explainerNPSPart1": "El Net Promoter Score es un índice que va de -100 a 100 y mide la disposición de los clientes a recomendar tu empresa o tus proyectos a otras personas.",
        "explainerOpinionScale": "Mide el grado de acuerdo de tus clientes con una afirmación general.",
        "fixed_choice": "Pregunta de opción múltiple",
        "hidePreview": "Ocultar vista previa",
        "moreInfo": "Más información",
        "nps": "Net Promoter Score",
        "npsQuestion": "NPS",
        "open_ended": "Respuesta abierta",
        "opinion_scale": "Escala de opinión",
        "preview": "Vista previa",
        "satisfaction": "Satisfacción",
        "selectSurveyType": "Seleccionar encuesta",
        "showPreview": "Mostrar vista previa",
        "tab_summary": "Resumen",
        "tab_units": "Unidades",
        "yes_no": "Sí o no"
      },
      "navigation": {
        "backToSurveyTypes": "Volver a encuestas"
      },
      "snackbars": {
        "duplicate": "Se ha creado la encuesta, pero el proceso de copia de la plantilla puede tardar unos minutos en completarse."
      },
      "toasts": {
        "bulk_delete": "Encuesta eliminada correctamente | Encuestas eliminadas correctamente",
        "update": "Encuesta actualizada correctamente"
      },
      "validation": {
        "nameAlreadyTaken": "El nombre ya está en uso para este proyecto",
        "need_name": "El título es obligatorio",
        "selectSurveyType": "Selecciona al menos 1 encuesta"
      }
    }
  }
}
